import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import SocialAccountsManager from './SocialAccountsManager';

export default function Navigation() {
  const location = useLocation();
  const { user, setUser } = useAuth();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleSignOut = () => {
    setUser(null);
  };

  const isInApp = user !== null;
  const isDashboard = location.pathname === '/';
  const showAppNav = isInApp && !isDashboard;

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100 fixed w-full top-0 z-50">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex justify-between items-center h-18">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src="https://www.followsmanager.com/images/FOLLOWERS-Presentation-2.svg"
                alt="Followers Manager"
                className="h-8"
              />
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            <div className="flex items-center space-x-1">
              {showAppNav && (
                <>
                  <Link
                    to="/inbox"
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                      isActive('/inbox')
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Inbox
                  </Link>
                  <Link
                    to="/scheduler"
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                      isActive('/scheduler')
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Post Scheduler
                  </Link>
                  <Link
                    to="/influencers"
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                      isActive('/influencers')
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Influencers
                  </Link>
                  <div className="w-px h-6 bg-gray-200 mx-2" />
                </>
              )}
              {!isInApp && (
                <Link
                  to="/pricing"
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                    isActive('/pricing')
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  Pricing
                </Link>
              )}
              {user && <SocialAccountsManager />}
              {user ? (
                <button
                  onClick={handleSignOut}
                  className="px-4 py-2 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Sign Out
                </button>
              ) : (
                <Link
                  to="/sign-in"
                  className="px-4 py-2 rounded-full text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors"
                >
                  Sign In
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}